<template>
  <m-row :gutter="24" style="align-items: center; display: flex">
    <m-col :span="isMobile ? 14 : 21">
      <m-input
        is-form-item
        :maxLength="4"
        v-model="localCaptcha"
        :label="$t('apply.title.verificationCode')"
        :placeholder="$t('apply.title.verificationCodeTip')"
        @input="updateCaptcha"
        :rules="[
          {
            required: true,
            message: this.$t('Common.message.required'),
          },
        ]"
      >
      </m-input>
    </m-col>
    <m-col :span="isMobile ? 10 : 4">
      <img v-if="captchaImg" @click="getCaptcha" :src="captchaImg" />
      <RedoOutlined v-else @click="getCaptcha" />
    </m-col>
  </m-row>
</template>

<script>
import { CaptchaAPI } from '@/api';
import RedoOutlined from '@ant-design/icons-vue/RedoOutlined';
import { is_mobile } from 'govmo-common/src/utils/utils';

export default {
  name: 'CaptchaText',
  props: {
    captcha: {
      type: String,
      default: '',
    },
  },
  components: {
    RedoOutlined,
  },
  data() {
    return {
      localCaptcha: this.captcha, // 使用本地变量同步父组件的值
      captchaImg: null,
      isMobile: is_mobile(),
    };
  },
  methods: {
    updateCaptcha(e) {
      this.localCaptcha = e.target.value; // 更新本地值
      this.$emit('input', e.target.value); // 向父组件发出更新事件
    },
    async getCaptcha() {
      try {
        this.$showLoading();
        const res = await CaptchaAPI.captcha();
        const item = new Blob([res], { type: 'image/png' });
        this.captchaImg = URL.createObjectURL(item);
      } catch (error) {
        console.error(error);
      } finally {
        this.$hideLoading();
      }
    },
  },
  watch: {
    captcha(newVal) {
      this.localCaptcha = newVal; // 监测父组件的值变化
    },
  },
  created() {
    this.getCaptcha();
  },
};
</script>

<style></style>
